// Mock attendance data for demonstration
export const mockAttendanceData = [
  {
    id: 1,
    studentId: 'S001',
    studentName: '張小明',
    class: '6A',
    date: '2024-01-15',
    status: 'present',
    timeIn: '08:00',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 2,
    studentId: 'S002',
    studentName: '李小華',
    class: '6A',
    date: '2024-01-15',
    status: 'present',
    timeIn: '08:05',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 3,
    studentId: 'S003',
    studentName: '王小美',
    class: '6A',
    date: '2024-01-15',
    status: 'late',
    timeIn: '08:30',
    timeOut: '15:30',
    notes: 'Traffic delay'
  },
  {
    id: 4,
    studentId: 'S004',
    studentName: '陳小強',
    class: '6A',
    date: '2024-01-15',
    status: 'absent',
    timeIn: null,
    timeOut: null,
    notes: 'Sick leave'
  },
  {
    id: 5,
    studentId: 'S005',
    studentName: '劉小芳',
    class: '6A',
    date: '2024-01-15',
    status: 'present',
    timeIn: '08:02',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 6,
    studentId: 'S001',
    studentName: '張小明',
    class: '6A',
    date: '2024-01-16',
    status: 'present',
    timeIn: '08:01',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 7,
    studentId: 'S002',
    studentName: '李小華',
    class: '6A',
    date: '2024-01-16',
    status: 'present',
    timeIn: '08:00',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 8,
    studentId: 'S003',
    studentName: '王小美',
    class: '6A',
    date: '2024-01-16',
    status: 'present',
    timeIn: '08:03',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 9,
    studentId: 'S004',
    studentName: '陳小強',
    class: '6A',
    date: '2024-01-16',
    status: 'present',
    timeIn: '08:00',
    timeOut: '15:30',
    notes: ''
  },
  {
    id: 10,
    studentId: 'S005',
    studentName: '劉小芳',
    class: '6A',
    date: '2024-01-16',
    status: 'present',
    timeIn: '08:01',
    timeOut: '15:30',
    notes: ''
  }
];

// Helper function to get attendance data by date range
export const getAttendanceByDateRange = (startDate, endDate) => {
  return mockAttendanceData.filter(record => {
    const recordDate = new Date(record.date);
    return recordDate >= new Date(startDate) && recordDate <= new Date(endDate);
  });
};

// Helper function to get attendance data by student
export const getAttendanceByStudent = (studentId) => {
  return mockAttendanceData.filter(record => record.studentId === studentId);
};

// Helper function to get attendance data by class
export const getAttendanceByClass = (className) => {
  return mockAttendanceData.filter(record => record.class === className);
};
